import React from "react";

const EventTile = ({ title, dates, image, url, venue, vertical }) => {
  const size = vertical ? 146 : 120;

  return (
    <a
      href={url}
      style={{
        display: "flex",
        flexDirection: vertical ? "column" : "row",
        padding: 8,
        gap: vertical ? 8 : 16,
        borderRadius: 8,
        border: "1px solid #EDF1F6",
        background: "#FFFFFF",
        boxShadow: "0 4px 8px 0 rgba(0, 0, 0, 0.08)",
        flex: "1 0 0",
        minWidth: vertical ? size + 16 : "calc((100% - 2*16px) / 3)",
        maxWidth: vertical ? size + 16 : "50%",
        scrollSnapAlign: "start",
        cursor: "pointer",
        textDecoration: "none",
      }}
    >
      <img
        src={image}
        style={{ display: "flex", width: size, height: size, borderRadius: 8 }}
      />
      <div
        style={{
          display: "flex",
          padding: vertical ? "0" : "8px 0",
          flexDirection: "column",
          gap: 4,
        }}
      >
        <span
          style={{
            color: "#703EFF",
            fontSize: 14,
          }}
        >
          {dates}
        </span>
        <span
          style={{
            color: "#0D0C1C",
            fontSize: 14,
            fontFamily: "pf_highway_sans_pro_mediumRg",
            display: "-webkit-box",
            overflow: "hidden",
            WebkitLineClamp: 3,
            WebkitBoxOrient: "vertical",
          }}
        >
          {title}
        </span>
        <span
          style={{
            height: 18,
            color: "#646567",
            fontSize: 14,
            lineHeight: "18px",
            marginTop: vertical ? "4px" : "auto",
            overflow: "hidden",
            WebkitLineClamp: 1,
            WebkitBoxOrient: "vertical",
          }}
        >
          {venue}
        </span>
      </div>
    </a>
  );
};

export default EventTile;
